// src/axiosConfig.js
import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5050',
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Include cookies nelle richieste cross-site
});

// Ottiene il token CSRF e lo imposta come intestazione predefinita
export const getCsrfToken = async () => {
  try {
    const response = await axiosInstance.get('/api/csrf-token');
    axiosInstance.defaults.headers['x-csrf-token'] = response.data.csrfToken;
  } catch (error) {
    console.error('Error fetching CSRF token:', error);
  }
};

// Interceptor per gestire errori di autenticazione
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Token scaduto o non valido
      console.log('Authentication error, redirecting to login...');
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Interceptor per aggiungere il token a ogni richiesta
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['x-auth-token'] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Imposta l'intestazione CSRF per tutte le richieste
getCsrfToken();

export default axiosInstance;